import axios from "../../utils/api/axios";
import { IAM_SERVER_SERVICE, IAM_SERVER_SSO_ADMIN } from "../../utils/Config";

const unwrap = (response) => response?.data?.data ?? response?.data ?? {};

export const ssoAdminApi = {
  async fetchServiceGroups(params = {}) {
    const response = await axios.get(`${IAM_SERVER_SSO_ADMIN}/service-groups`, {
      params,
    });
    return unwrap(response);
  },

  async createServiceGroup(payload) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/service-groups`,
      payload
    );
    return unwrap(response);
  },

  async checkServiceGroupDuplicate(params = {}) {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/check-duplicate`,
      {
        params,
      }
    );
    return unwrap(response);
  },

  async fetchServiceGroupDetail(groupId, params = {}) {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}`,
      {
        params,
      }
    );
    return unwrap(response);
  },

  async fetchServiceGroupMemberCatalog(groupId, params = {}) {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}/member-catalog`,
      {
        params,
      }
    );
    return unwrap(response);
  },

  async updateServiceGroup(groupId, payload) {
    const response = await axios.patch(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}`,
      payload
    );
    return unwrap(response);
  },

  async deleteServiceGroup(groupId) {
    const response = await axios.delete(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}`
    );
    return unwrap(response);
  },

  async addServiceGroupMember(groupId, payload) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}/members`,
      payload
    );
    return unwrap(response);
  },

  async updateServiceGroupMember(groupId, memberId, payload) {
    const response = await axios.patch(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}/members/${memberId}`,
      payload
    );
    return unwrap(response);
  },

  async deleteServiceGroupMember(groupId, memberId) {
    const response = await axios.delete(
      `${IAM_SERVER_SSO_ADMIN}/service-groups/${groupId}/members/${memberId}`
    );
    return unwrap(response);
  },

  async createFederationRequest(payload) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/federations/requests`,
      payload
    );
    return unwrap(response);
  },

  async fetchFederations(params = {}) {
    const response = await axios.get(`${IAM_SERVER_SSO_ADMIN}/federations`, {
      params,
    });
    return unwrap(response);
  },

  async fetchPendingFederations(params = {}) {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/federations/pending`,
      {
        params,
      }
    );
    return unwrap(response);
  },

  async fetchFederationDetail(federationId) {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/federations/${federationId}`
    );
    return unwrap(response);
  },

  async approveFederation(federationId) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/federations/${federationId}/approve`
    );
    return unwrap(response);
  },

  async rejectFederation(federationId, payload) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/federations/${federationId}/reject`,
      payload
    );
    return unwrap(response);
  },

  async evaluatePolicy(payload) {
    const response = await axios.post(
      `${IAM_SERVER_SSO_ADMIN}/policy/evaluate`,
      payload
    );
    return unwrap(response);
  },

  async fetchOperationPolicy() {
    const response = await axios.get(
      `${IAM_SERVER_SSO_ADMIN}/operation-policy`
    );
    return unwrap(response);
  },

  async fetchServicesByTenant(tenantId) {
    const response = await axios.post(`${IAM_SERVER_SERVICE}/all`, {
      sortField: ["serviceName"],
      sortOrder: ["asc"],
      operator: "AND",
      conditions: tenantId
        ? [{ field: "createdBy", operator: "EQUALS", value: tenantId }]
        : [],
    });

    const data = unwrap(response);
    return data?.data ?? data?.items ?? [];
  },
};
